module.exports = __webpack_public_path__ + "files/1f2b76c802a4bbaf77573a9c57c5fa80.svg";